module.exports = __webpack_public_path__ + "static/media/Image-Blog.caf057ca.jpg";